import { useSelector } from 'react-redux';
import { RootState } from 'redux/store/rootReducer';
import styled, { keyframes } from 'styled-components';

const NormalBldInfoModal = () => {
  const BUILDING_NAME_MAX_LENGTH = 20;
  const COMPLEX_PLAT_PLC_MAX_LENGTH = 23;
  const { normalMarkerInfo } = useSelector(
    (state: RootState) => state.mapStore,
  );
  const {
    bldNm,
    complexPlatPlc,
    complexNum,
    layoutPublicAreaMsMax,
    layoutPublicAreaMsMin,
    complexUseDay,
    imageUrl,
  } = normalMarkerInfo;

  const truncatedBuildingName =
    bldNm.length > BUILDING_NAME_MAX_LENGTH
      ? `${bldNm.substring(0, 17)}..`
      : `${bldNm}`;

  const truncatedBuildingAddress =
    complexPlatPlc.length > COMPLEX_PLAT_PLC_MAX_LENGTH
      ? `${complexPlatPlc.substring(0, 21)}..`
      : `${complexPlatPlc}`;

  const send = () => {
    const normalsendData = JSON.stringify(normalMarkerInfo);

    if (window?.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(normalsendData);
    } else {
      console.log('Web Console');
    }
  };

  return (
    <>
      <Container onClick={send}>
        <ContainerTwo>
          <TopSection>
            <TopLeftSection>
              <BldName>{truncatedBuildingName}</BldName>
              <BldInfo>{truncatedBuildingAddress}</BldInfo>
              <BldInfoWrapper>
                <BldInfo>{`${complexNum} 세대`} </BldInfo>
                <DottedHL>|</DottedHL>
                <BldInfo>
                  {`${layoutPublicAreaMsMin}m\xB2`}
                  {`~ ${layoutPublicAreaMsMax}m\xB2`}
                </BldInfo>
                <DottedHL>|</DottedHL>
                <BldInfo>{`${complexUseDay}`}</BldInfo>
              </BldInfoWrapper>
            </TopLeftSection>
            <TopRightSection
              src={imageUrl || '/images/no_im.svg'}
              alt="no-img"
            />
          </TopSection>
        </ContainerTwo>
      </Container>
    </>
  );
};

export default NormalBldInfoModal;

const breatheAnimation = keyframes`
  from {
    bottom: -200px;
  }
  to {
    bottom: 0px;
 }
`;

const Container = styled.div`
  background-color: #ffffff;
  width: 100%;
  position: absolute;
  z-index: 555;
  animation-name: ${breatheAnimation};
  animation-duration: 0.1s;
  animation-timing-function: ease-in;
  bottom: 0;
  box-shadow: 0px 0px 8px rgba(0, 30, 81, 0.12);
`;

const ContainerTwo = styled.div`
  min-height: 120px;
  padding: 16px;
  justify-content: center;
`;

const TopSection = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const TopLeftSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TopRightSection = styled.img`
  border-radius: 8px;
  width: 80px;
  height: 64px;
`;

const BldName = styled.div`
  text-overflow: ellipsis;
  font-family: Pretendard;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
`;

const BldInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BldInfo = styled.div`
  font-family: Pretendard;
  font-size: 12px;
  color: #333333;
  :nth-child(2) {
    margin: 8px 0 4px 0;
  }
`;

const DottedHL = styled.div`
  color: #e6e6e6;
  margin: 0px 4px;
`;
